var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYabx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "197px",
    height: "60px",
    viewBox: "0 0 197 60",
    style: {
      enableBackground: "new 0 0 197 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0F0F0F;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,0h137c16.6,0,30,13.4,30,30l0,0c0,16.6-13.4,30-30,30H30C13.4,60,0,46.6,0,30l0,0C0,13.4,13.4,0,30,0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.9,43.6c-0.6,0.6-1.5,0.6-2,0l-3.4-3.5v-5.6h-5.6L25.4,31c-0.6-0.6-0.6-1.5,0-2l12.5-12.6  c0.6-0.6,1.5-0.6,2,0L52.4,29c0.6,0.6,0.6,1.5,0,2L39.9,43.6L39.9,43.6z M38.9,21.5L30.5,30l8.4,8.5l8.4-8.5L38.9,21.5L38.9,21.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163,30l9.8,9.3h-4.3l-7.6-7.3l-7.7,7.3h-4.3l9.8-9.3l-9.8-9.4h4.3l7.7,7.3l7.7-7.3h4.3L163,30L163,30z   M136,39.4h-16.1V20.7h15.4c2.6,0,4.8,2.4,4.8,5.3c0,1.1-0.3,2.2-0.9,3.1l-0.2,0.3l0.3,0.3c1.1,1,1.7,2.5,1.7,4.1V34  C141,36.9,138.7,39.4,136,39.4L136,39.4z M135.2,28.4c1.1,0,2-1.3,2-2.6c0-1.3-0.9-2.5-2-2.5h-12.3v13.2h13.3c1.2,0,2.2-1.4,2.2-2.7  c0-1.3-1-2.6-2.2-2.6h-9.8l0-2.8H135.2z M105.9,35.3h-9.5l1.4-2.6h6.6l-5.1-8.9l-8.5,15.6h-3.2c1-1.9,7.4-13.8,10-17.9  c0.5-0.7,1.1-1,1.7-1c0.6,0,1.2,0.3,1.7,1c2.7,4.2,9.2,16,10.3,17.9h-3L105.9,35.3z M74,32.4v6.9h-3v-6.9L60.5,20.6H64l8.5,9.6  l8.4-9.6h3.5L74,32.4L74,32.4L74,32.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYabx);
export default __webpack_public_path__ + "static/media/yabx.4ef1c14ea911fd54211e4edae8838751.svg";
export { ForwardRef as ReactComponent };